import {
  IncidentAdapterInteface,
  ListIncidentsInput,
} from 'src/adapter/IncidentAdapterInterface';
import { IncidentModelAttributes } from 'src/models/IncidentModel';
import { NotFoundException, Exception } from 'src/exceptions';
import { Incidents } from 'src/mock/incidents';
export class MockIncidentAdapter implements IncidentAdapterInteface {
  listIncidents(
    conditions: ListIncidentsInput
  ): Promise<{ total: number; incidents: IncidentModelAttributes[] }> {
    return new Promise(function (resolve) {
      setTimeout(() => {
        try {
          let res = { total: 0, incidents: [] };
          const incidents = Incidents;
          const start = conditions.page * conditions.limit - conditions.limit;
          const end = start + conditions.limit;
          const newIncidents = incidents.slice(start, end);
          res = {
            total: incidents.length,
            incidents: newIncidents,
          };
          resolve(res);
        } catch (e) {
          throw new Exception();
        }
      }, 1000);
    });
  }
  getIncident(id: string): Promise<IncidentModelAttributes> {
    return new Promise(function (resolve) {
      setTimeout(() => {
        try {
          const incidents = Incidents;
          const res = incidents.find((item: { id: string }) => item.id == id);
          if (!res) throw new NotFoundException();
          resolve(res);
        } catch (e) {
          throw new Exception();
        }
      }, 1000);
    });
  }
}
